import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { TestItem } from "../types";

interface RemoveTestConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  test: TestItem | null;
}

export function RemoveTestConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  test,
}: RemoveTestConfirmationModalProps) {
  if (!test) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl">Confirmation</DialogTitle>
        </DialogHeader>
        <div className="py-6">
          <p className="text-center text-gray-700 mb-6">
            The following item will be removed permanently. Are you sure you want to remove this item?
          </p>

          <div className="flex items-start mb-8">
            <div className="h-3 w-3 mt-1.5 rounded-full bg-emerald-500 flex-shrink-0" />
            <div className="ml-3">
              <h3 className="font-medium text-gray-900">
                {test.testName}
              </h3>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              className="w-full bg-blue-600 hover:bg-blue-700"
              onClick={onConfirm}
            >
              Remove
            </Button>
            <Button
              className="w-full text-red-500"
              variant="outline"
              onClick={onClose}
            >
              Cancel
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
